import { getUA } from "react-device-detect";

export const isJiajiaClassApp =
  navigator.userAgent.toLocaleLowerCase().indexOf("jiajiaclass") > -1;

export const sendMessageToApp = (message: any) => {
  (window as any)?.ReactNativeWebView.postMessage(JSON.stringify(message));
};

export const isInWebView = () => {
  const userAgent = getUA.toLowerCase();

  const isAndroidWebView =
    /(android).*(wv|version\/\d[\d.]*\s(mobile|safari))/i.test(userAgent);
  const isIOSWebView = /(iphone|ipad|ipod).*applewebkit(?!.*safari)/i.test(
    userAgent
  );

  return isAndroidWebView || isIOSWebView || userAgent.includes("jiajiaclass");
};

export const isMobileAndOldVersion = () => {
  const uA = navigator.userAgent;

  const match = uA.match(/(\d+\.\d+\.\d+)$/);
  if (!match) return false;

  const versionStr = match[0];
  // 移除小数点，转换为整数
  // 2.0.0 → 200, 1.2.3 → 123
  const versionNumber = parseInt(versionStr.replace(/\./g, ""));

  return (
    uA.toLocaleLowerCase().indexOf("jiajiaclass") > -1 && versionNumber < 200
  );
};

export const isOldVersion = () => {
  const uA = navigator.userAgent;

  const match = uA.match(/(\d+\.\d+\.\d+)$/);
  if (!match) return false;

  const versionStr = match[0];
  // 移除小数点，转换为整数
  // 2.0.0 → 200, 1.2.3 → 123
  const versionNumber = parseInt(versionStr.replace(/\./g, ""));

  return versionNumber < 200;
};
